<template>
  <div class="w-full">
    <input
      v-bind="$attrs"
      class="mr-2"
      type="radio"
      :name="name"
      :disabled="disabled"
      :value="val"
      :id="`inputRadio-${uuid}`"
      :readonly="readonly"
      :aria-errormessage="`inputRadio-error-${uuid}`"
    />
    <label v-if="label" :for="`inputRadio-${uuid}`">
      {{ label }}
    </label>
  </div>
</template>

<script>
import input from 'Mixins/input';
import uuid from 'Mixins/uuid';

export default {
  name: 'InputRadio',
  mixins: [input, uuid],
  props: {
    label: {
      type: String,
      default: null,
    },
  },
};
</script>
